export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets100_strips150_scale_gray@2x.965c8fa0.webp";